{
    "AUTH_TOKEN_INVALID": "Your session is invalid. Please sign in again.",
    "AUTH_TOKEN_EXPIRED": "Your session has expired. Please sign in again.",
    "AUTH_TOKEN_REUSE_DETECTED": "Reuse of a revoked token detected. All sessions have been signed out for security.",
    "AUTH_PERM_VERSION_STALE": "Your permissions have changed. Refreshing your session...",
    "AUTH_PERMISSION_DENIED": "You don't have permission to perform this action.",
    "AUTH_CSRF_MISSING": "Missing CSRF protection token. Please reload the page.",
    "AUTH_CSRF_MISMATCH": "CSRF token mismatch. Please reload the page.",
    "AUTH_RATE_LIMIT_EXCEEDED": "Too many requests. Please try again later.",
    "AUTH_RECAPTCHA_FAILED": "reCAPTCHA verification failed. Please try again.",
    "AUTH_RECAPTCHA_TOKEN_MISSING": "Missing reCAPTCHA token. Please try again.",
    "AUTH_OTP_INVALID": "The OTP code is invalid or has expired.",
    "AUTH_OTP_RESEND_TOO_FAST": "OTP resend requested too quickly. Please wait before trying again.",
    "AUTH_PASSWORD_REUSED": "You cannot reuse one of your last 5 passwords.",
    "AUTH_ACCOUNT_LOCKED": "Your account has been locked due to too many failed sign-in attempts.",
    "AUTH_LAST_SUPERADMIN": "Cannot proceed — this is the last active superadmin.",
    "AUTH_SETUP_TOKEN_INVALID": "The setup token is invalid or has expired.",
    "AUTH_PORTAL_ACCESS_DENIED": "Your account does not have access to this portal.",
    "AUTH_WS_ORIGIN_REJECTED": "WebSocket origin is not allowed.",
    "AUTH_WS_TICKET_INVALID": "WebSocket ticket is invalid or has already been used.",
    "AUTH_OAUTH_STATE_INVALID": "OAuth state parameter is invalid. Please try signing in again.",
    "AUTH_IMPERSONATE_DENYLIST_ACTION": "This action is blocked while impersonating another user.",
    "AUTH_FORCE_RELOGIN": "Your access has changed. Please sign in again.",
    "VENDOR_REAPPLY_COOLDOWN": "Please wait for the cooldown period before resubmitting the vendor application."
}
